<template>
  <ts-card>
    <ts-card-wrapper>
      <p>{{ $t('message') }}</p>
      <div class="row">
        <div class="col-sm-6">
          <ts-date-picker-input v-model="date" />
        </div>
        <div class="col-sm-6">
          <ts-time-picker-input v-model="time" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-12">
          <div>
            <ts-button
              class="mr-1"
              @click="$toasted.show('Awesome')"
              v-tooltip="'Default'"
            >
              Toasted default
            </ts-button>
            <ts-button
              color="success"
              class="mr-1"
              @click="$toasted.success('Awesome')"
              >Toasted success</ts-button
            >
            <ts-button
              color="danger"
              class="mr-1"
              @click="$toasted.error('Awesome')"
              >Toasted error</ts-button
            >
            <ts-button
              color="info"
              class="mr-1"
              @click="$toasted.info('Awesome')"
              >Toasted info</ts-button
            >
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-12">
          <ts-button color="danger" @click="deleteSomething">
            Confirm Delete
          </ts-button>
        </div>
      </div>
      <div class="row mt-4">
        <ts-tabs target="gTab">
          <ts-tab>T1</ts-tab>
          <ts-tab>T2</ts-tab>
          <ts-tab>T3</ts-tab>
        </ts-tabs>
        <ts-tab-panes name="gTab">
          <ts-tab-pane>
            1
          </ts-tab-pane>
          <ts-tab-pane>
            2
          </ts-tab-pane>
          <ts-tab-pane>
            3
          </ts-tab-pane>
        </ts-tab-panes>
      </div>
      <div class="row mt-4">
        <div class="col-sm-6">
          <ts-image-input
            class="father-image-input"
            file="https://images.unsplash.com/photo-1503919545889-aef636e10ad4?auto=format&fit=crop&w=334&h=334"
            @input="file => (fileModel = file)"
            :width="300"
            :height="300"
            crop
          ></ts-image-input>
        </div>
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      date: null,
      fileModel: null,
      time: null
    }
  },
  methods: {
    async deleteSomething() {
      if (await this.$confirmModal.danger('Are you sure to delete?')) {
        this.$toasted.success('Deleted')
      }
    }
  }
}
</script>
